var map = {
	"./alliance-retail-group_logo.png": "u22F",
	"./arg_logo.png": "+AHo",
	"./awg_logo.png": "F8A3",
	"./ipro_logo.png": "1eXb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bxF2";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*_logo\.png$
// module id = bxF2
// module chunks = 10